import { useState, useContext, useEffect ,useCallback} from 'react';
import DepartmentTable from '../components/departments/DepartmentTable';
import { Box, Container, Modal } from '@mui/material';
import { Select, Button, TextInput } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faDownload } from '@fortawesome/free-solid-svg-icons';
import { getCompanyDepartment ,getAllDepartments,getCompanies,addDepartment,editDepartment,deleteAllDepartment,deleteDepartment} from '../apis/axios';

import AuthContext from '../AuthContext';
// Static companies data

function Departments() {
   const auth = useContext(AuthContext);
  const [companies ,setCompanies] = useState([]); // Use static companies
  const [departments, setDepartments] = useState([]);
  const[company,setCompany]=useState('');
  const [tableInstance, setTableInstance] = useState(null);
  const [update,setUpdate]=useState(false)
  const handleUpdate=()=>{
    setUpdate(!update)
  }
const fetchCompanies=async()=>{
  try{
    const response=await getCompanies();
     if (response && Array.isArray(response.data)) {
      setCompanies(response.data);
    } else {
      console.error('Invalid response format for departments:', response.data);
      setCompanies([]);
    }
  }
   catch (error) {
    console.error('Error fetching departments:', error);
    setCompanies([]);
  }
}
//console.log(companies)
useEffect(()=>{
  fetchCompanies()
},[update])
const fetchDepartments = useCallback(async () => {
  try {
    const response = await getCompanyDepartment(company);
    //console.log('Departments response:', response.data);
    if (response) {
      setDepartments(response.data);
    } else {
      console.error('Invalid response format for departments:', response.data);
      setDepartments([]);
    }
  } catch (error) {
    console.error('Error fetching departments:', error);
    setDepartments([]);
  }
}, [company]);

const fetchAllDepartments = useCallback(async () => {
  try {
    const response = await getAllDepartments(company);
    //console.log('Departments response:', response.data);
    if (response) {
      setDepartments(response.data);
    } else {
      console.error('Invalid response format for departments:', response.data);
      setDepartments([]);
    }
  } catch (error) {
    console.error('Error fetching departments:', error);
    setDepartments([]);
  }
}, [company]);
useEffect(() => {
  if (auth.admin) {
    setCompany(auth.admin); // update company only when admin is ready
  }
}, [auth.admin , update]);

useEffect(() => {
  if (company) {
    fetchDepartments();
  }else{
    fetchAllDepartments()
  }
}, [company, fetchDepartments ,update]);

  // State for modal
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    name: '',
  });
  const [isEditing, setIsEditing] = useState(false);

  // Function to export data as CSV
  const exportToCSV = (data, filename) => {
    const headers = ['Department', 'Company'];
    const rows = data.map(item => [
      item.name,
      item.company_name,
    ]);
    const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.click();
    URL.revokeObjectURL(url);
  };

  // Handle form input changes
  const handleInputChange = (field, value) => {
    if (field === 'companyId') {
      const selectedCompany = companies.find(company => company.id === parseInt(value));
      setFormData(prev => ({
        ...prev,
        companyId: value,
        companyName: selectedCompany ? selectedCompany.name : '',
      }));
    } else {
      setFormData(prev => ({ ...prev, [field]: value }));
    }
  };
  // Handle form submission for adding a new department
  const handleAddDepartment = async() => {
    const newDepartment = {
      name: formData.name,
      company_id: company,
    };
    try {
      const res=await addDepartment(newDepartment);
      //console.log(res)
      if(res){
        handleUpdate()
      }
    } catch (error) {
      //console.log(error)
      
    }
    closeModal();
  };

  // Handle form submission for updating an existing department
  const handleUpdateDepartment = () => {
     const newDepartment = {
      id:formData.id,
      name: formData.name,
      company_id: company,
    };
  try {
    const res=editDepartment(newDepartment)
    if(res){
      handleUpdate()
    }
  } catch (error) {
    //console.log(error)
  }
    closeModal();
  };

  // Handle edit department
  const handleEditDepartment = (department) => {
    setFormData({
      id: department.id,
      name: department.name,
      companyId: department.company_id,
    });
    setCompany(department.company_id)
    setIsEditing(true);
    setOpenModal(true);
  };

  // Handle bulk actions
 const handleBulkAction = async (action) => {
  if (!tableInstance) return;

  let departmentIds = [];

  if (action === 'deleteAll') {
    // Get all department IDs
    departmentIds = departments.map(dep => dep.id);
  } else if (action === 'deleteSelected') {
    const selectedRows = tableInstance.getSelectedRowModel().rows;
    departmentIds = selectedRows.map(row => row.original.id);
  }

  if (departmentIds.length === 0) return;

  try {
    // Send to API in format department_ids=[1,2,3]
   const res= await deleteAllDepartment({ department_ids: departmentIds });
   //console.log(res)
   handleUpdate()

    // Reset row selection if applicable
    if (action === 'deleteSelected') {
      tableInstance.resetRowSelection();
    }

  } catch (error) {
    console.error('Error during bulk deletion:', error);
  }
};

const handleDelete=async(data)=>{
  try {
    const res= await deleteDepartment({department_id:data})
    //console.log(res)
    if(res){
      handleUpdate()
    }
  } catch (error) {
    //console.log(error)
    
  }
}
  // Close modal and reset form
  const closeModal = () => {
    setOpenModal(false);
    setIsEditing(false);
    setFormData({
      id: null,
      name: '',
      companyId: '',
      companyName: '',
    });
  };

  // Ripple effect handler
  const handleRippleEffect = (e) => {
    const button = e.currentTarget;
    const ripple = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${e.clientX - button.getBoundingClientRect().left - radius}px`;
    ripple.style.top = `${e.clientY - button.getBoundingClientRect().top - radius}px`;
    ripple.classList.add('export-button-ripple');

    button.appendChild(ripple);

    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  return (
    <Box display="flex" sx={{ maxWidth: 'none', justifyContent: 'center' }}>
      <Box flexGrow={1} ml={{ sm: 0 }} sx={{ maxWidth: 'none' }}>
        <Container
          className="py-4"
          sx={{
            maxWidth: 'none !important',
            overflowX: 'hidden',
            paddingLeft: 0,
            paddingRight: 0,
          }}
        >
          <div style={{ margin: '0 auto', width: '75.5vw', maxWidth: '75.5vw' }}>
            {/* Header and Buttons */}
             <div className="md:flex-row lg:flex-row xl:flex-row flex justify-between items-center mb-4 flex-col ">
              <div className="flex md:flex-row flex-col items-center">
                 <h1
                  style={{
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: '32px',
                    fontWeight: 700,
                    color: '#202224',
                  }}
                >
                  Department
                </h1>
              </div>
              <div className="flex flex-col md:flex-row xl:flex-row lg:flex-row gap-[15px] md:gap:5 align-middle">
                
                <Button
                  size="sm"
                  variant="filled"
                  className="export-button"
                  styles={{
                    root: {
                      width: '120px',
                      height: '36px',
                      backgroundColor: '#FF7A00',
                      borderRadius: '20px',
                      padding: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      border: 'none',
                      cursor: 'pointer',
                      boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                      '&:hover': {
                        backgroundColor: '#FF7A00',
                      },
                    },
                    label: {
                      fontFamily: 'Nunito Sans, sans-serif',
                      fontSize: '14px',
                      fontWeight: 500,
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                    },
                  }}
                  onClick={(e) => {
                    handleRippleEffect(e);
                    exportToCSV(departments, 'departments.csv');
                  }}
                >
                  <FontAwesomeIcon
                    icon={faDownload}
                    style={{
                      height: '10px',
                      width: '10px',
                      color: '#fff',
                    }}
                  />
                  <span>Export</span>
                </Button>
                <Button
                  size="sm"
                  variant="filled"
                  className="export-button"
                  styles={{
                    root: {
                      width: '150px',
                      height: '36px',
                      backgroundColor: '#FF7A00',
                      borderRadius: '20px',
                      padding: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      border: 'none',
                      cursor: 'pointer',
                      boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                      '&:hover': {
                        backgroundColor: '#FF7A00',
                      },
                    },
                    label: {
                      fontFamily: 'Nunito Sans, sans-serif',
                      fontSize: '14px',
                      fontWeight: 500,
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    },
                  }}
                  onClick={(e) => {
                    handleRippleEffect(e);
                    setOpenModal(true);
                    setIsEditing(false);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faPlus}
                    style={{
                      height: '10px',
                      width: '10px',
                      color: '#fff',
                    }}
                  />
                  <span>Add Departments</span>
                </Button>
              </div>
            </div>

            {/* Department Table */}
            <div>
              <DepartmentTable
                data={departments}
                setDepartments={setDepartments}
                onEdit={handleEditDepartment}
                onDelete={handleDelete}
                setTableInstance={setTableInstance}
                userType={auth.userType}
              />
            </div>
          </div>

          {/* Add/Edit Department Modal */}
          <Modal
            open={openModal}
            onClose={closeModal}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                backgroundColor: '#F7F7F7',
                padding: '20px 30px',
                borderRadius: '8px',
                width: '90vw',
                maxWidth: '900px',
                position: 'relative',
                maxHeight: { xs: '90vh', sm: 'none' },
                overflowY: { xs: 'auto', sm: 'hidden' },
                boxShadow: '6px 6px 6px #00000040',
              }}
            >
              {/* Modal Header */}
              <div className="flex justify-between items-center mb-4">
                <h1
                  style={{
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: '30px',
                    fontWeight: 700,
                    color: '#202224',
                  }}
                >
                  {isEditing ? 'Edit Department' : 'Add Department'}
                </h1>
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{
                    height: '17px',
                    width: '17px',
                    color: '#FF7A00',
                    cursor: 'pointer',
                  }}
                  onClick={closeModal}
                />
              </div>

              {/* Department Information Section */}
              <h2
                style={{
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: { xs: '18px', sm: '20px' },
                  fontWeight: 700,
                  color: '#202224',
                  marginBottom: '16px',
                }}
              >
                Department Information
              </h2>
              <div className="flex flex-col sm:flex-row gap-3 mb-4">
                {/* Department Name */}
                <div className="flex flex-col flex-1">
                  <label
                    style={{
                      fontFamily: 'Nunito Sans, sans-serif',
                      fontSize: { xs: '10px', sm: '12px' },
                      fontWeight: 600,
                      color: '#202224',
                      marginBottom: '6px',
                    }}
                  >
                    Department Name*
                  </label>
                  <TextInput
                    value={formData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    placeholder="e.g., IT Department"
                    styles={{
                      input: {
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '10px', sm: '12px' },
                        color: '#595C60',
                        backgroundColor: '#FCFCFC',
                        border: '0.6px solid #595C60',
                        borderRadius: '6px',
                        width: '100%',
                        maxWidth: { xs: '100%', sm: '200px' },
                        height: { xs: '36px', sm: '40px' },
                        '&:focus': {
                          borderColor: '#FF6B00',
                          outline: 'none',
                        },
                      },
                    }}
                  />
                </div>
                {/* Company */}
                {auth.userType==='antima' &&(
                  <>
                  <div className="flex flex-col flex-1">
                  <label
                    style={{
                      fontFamily: 'Nunito Sans, sans-serif',
                      fontSize: { xs: '10px', sm: '12px' },
                      fontWeight: 600,
                      color: '#202224',
                      marginBottom: '6px',
                    }}
                  >
                    Company*
                  </label>
                  <Select
                    value={company}
                    onChange={(value) => setCompany(value)}
                    data={companies.map(company => ({
                      value: company.id,
                      label: company.name,
                    }))}
                    placeholder="Select Company"
                    styles={{
                      input: {
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '10px', sm: '12px' },
                        color: '#595C60',
                        backgroundColor: '#FCFCFC',
                        border: '0.6px solid #595C60',
                        borderRadius: '6px',
                        width: '100%',
                        maxWidth: { xs: '100%', sm: '200px' },
                        height: { xs: '36px', sm: '40px' },
                        '&:focus': {
                          borderColor: '#FF6B00',
                          outline: 'none',
                        },
                      },
                      item: {
                        fontFamily: 'Nunito Sans, sans-serif',
                        fontSize: { xs: '10px', sm: '12px' },
                        color: '#595C60',
                        '&[data-selected]': {
                          backgroundColor: '#FF6B00',
                          color: '#FFFFFF',
                          '&:hover': {
                            backgroundColor: '#FF6B00',
                            color: '#FFFFFF',
                          },
                        },
                        '&:hover': {
                          backgroundColor: '#FFF3E5',
                        },
                      },
                    }}
                  />
                </div>
                  </>
                )}
              </div>

              {/* Add/Update Department Button */}
              <div className="flex justify-end">
                <Button
                  className="export-button"
                  styles={{
                    root: {
                      width: { xs: '100px', sm: '120px' },
                      height: { xs: '32px', sm: '36px' },
                      backgroundColor: '#FF7A00',
                      borderRadius: '20px',
                      padding: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: 'none',
                      cursor: 'pointer',
                      boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                      '&:hover': {
                        backgroundColor: '#FF7A00',
                      },
                    },
                    label: {
                      fontFamily: 'Nunito Sans, sans-serif',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: 500,
                      color: '#fff',
                    },
                  }}
                  onClick={(e) => {
                    handleRippleEffect(e);
                    isEditing ? handleUpdateDepartment() : handleAddDepartment();
                  }}
                  disabled={!formData.name || !company}
                >
                  {isEditing ? 'Update Department' : 'Add Department'}
                </Button>
              </div>
            </div>
          </Modal>
        </Container>
      </Box>

      {/* Ripple Effect Styles */}
      <style>
        {`
          .export-button {
            position: relative;
            overflow: hidden;
          }
          .export-button-ripple {
            position: absolute;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.4);
            transform: scale(0);
            animation: ripple 0.6s linear;
            pointer-events: none;
          }
          @keyframes ripple {
            to {
              transform: scale(4);
              opacity: 0;
            }
          }
        `}
      </style>
    </Box>
  );
}

export default Departments;